import { getBrandStyle } from '@dap/common/styles';
import { BrandStyles } from '@dap/common/types';
import { useSelectedBrandKey } from './brandSelectors';

export function useBrandStyle(brandKey?: string): BrandStyles {
  const selectedBrandKey = useSelectedBrandKey();
  return getBrandStyle(brandKey ?? selectedBrandKey);
}
